import BlankSpaceLogo from "../img/BlankSpace.jpg";
import WelaLogo from "../img/wela-logo.svg";
import StiLogo from "../img/sti-logo.png";
import K9Logo from "../img/K9.png";
import GtcdLogo from "../img/GTCD.jpg";
import Avatar from "../img/Picture.png";

// `logo` is shown in the timeline circle; entries without one show `initials`.
// `logoFill` stretches logos with a solid background to fill the circle.
const experiencesData = [
  {
    title: "FullStack Developer (Freelance)",
    location: "Work from Home",
    description:
      "Spent 5 months as a Information System Instructor at STI College Tagum, Teaching IS subjects, and Programming",
    date: "2024 - 2025 10 months",
    company: "Freelance FullStack Developer",
    logo: Avatar,
    logoFill: true,
  },
  {
    title: "IS Instructor (Part-Time)",
    location: "Apokon, Tagum City",
    description:
      "Spent 5 months as a Information System Instructor at STI College Tagum, Teaching IS subjects, and Programming",
    date: "2024 - 6 months",
    company: "STI Tagum",
    logo: StiLogo,
    logoFill: true,
  },
  {
    title: "Web Designer",
    location: "Davao City, Eco-land, Philippines",
    description: "Lead Designer for website design on ecommerce for 3 months",
    date: "2024 - 3 months",
    company: "K9maniadogtraining.com",
    logo: K9Logo,
  },
  {
    title: "Web Developer 1",
    location: "Panabo City, Philippines",
    description:
      "Spent 1 year and 3 months as a Web developer 1 is to add new features, improve the user interface, and integrate API's.",
    date: "2023 - 2024 - 1 year 3 months",
    company: "Blank Space",
    logo: BlankSpaceLogo,
  },
  {
    title: "IT Instructor (Part-Time)",
    location: "Lasang, Davao City, Philippines",
    description:
      "Taught computer programming, database management, and web development.",
    date: "2022 - 2023 - 1 year",
    company: "Gabriel Taborin College of Davao Foundation, Inc.",
    logo: GtcdLogo,
  },
  {
    title: "UI/UX Designer (Intern)",
    location: "Cagayan de Oro City, Philippines (Remote)",
    description:
      "Before I graduated I apply as an intern at Wela School Systems as a UI/UX Designer in 6 months. I learned a lot from User Interface to User Experience.",
    date: "Jan - May 2022 - 5 months",
    company: "Wela School Systems",
    logo: WelaLogo,
  },
];

export default experiencesData;
